import { replacePipesWithDashes } from '@/lib/item-master/replacePipesWithDashes';

import { csvCell, csvReasonList } from './csvCell';
import type {
  FlaggedPotfUpcRow,
  FlaggedVendorItemListRow,
  FlaggedWebNoPriceRow,
} from './types';

const WEB_NO_PRICE_CSV_HEADERS = [
  'File',
  'Sheet',
  'Row',
  'DIV',
  'Product',
  'Description',
  'Type',
  'In Stock',
  'Status',
  'USER DEF-2',
  'USER DEF-9',
  'Reasons',
] as const;

const POTF_UPC_CSV_HEADERS = [
  'File',
  'Sheet',
  'Row',
  'Product Loc',
  'Int',
  'Product',
  'UPC',
  'Group',
  'Subgroup',
  'Description',
  'First Supplier',
  'Vendor',
  'Status',
  'Other Part#',
  'Other Divisions',
  'Reasons',
] as const;

function csvLines(
  headers: readonly string[],
  rows: readonly string[][],
): string {
  return `${[headers.join(','), ...rows.map((row) => row.map(csvCell).join(','))].join('\n')}\n`;
}

export function webNoPriceRowsToCsv(
  rows: readonly FlaggedWebNoPriceRow[],
): string {
  return csvLines(
    WEB_NO_PRICE_CSV_HEADERS,
    rows.map((row) => [
      row.fileName,
      row.sheetName,
      String(row.sheetRow),
      row.div,
      row.productNumber,
      row.description,
      row.productType,
      row.inStock,
      row.recordStatus,
      row.userDef2,
      row.userDef9,
      csvReasonList(row.reasons),
    ]),
  );
}

export function potfUpcRowsToCsv(rows: readonly FlaggedPotfUpcRow[]): string {
  return csvLines(
    POTF_UPC_CSV_HEADERS,
    rows.map((row) => [
      row.fileName,
      row.sheetName,
      String(row.sheetRow),
      row.productLoc,
      row.productInt,
      row.productNumber,
      row.upcCode,
      row.productGroup,
      row.subgroup,
      row.description,
      row.firstSupplier,
      row.vendorName,
      row.productStatus,
      row.otherPartNumber,
      row.otherDivisions,
      csvReasonList(row.reasons),
    ]),
  );
}

export function vendorItemListUploadCells(row: {
  productNumber: string;
  englishDescription: string;
  frenchDescription: string;
}): string[] {
  const english = replacePipesWithDashes(row.englishDescription);
  const frenchSource =
    row.frenchDescription === ''
      ? row.englishDescription
      : row.frenchDescription;
  return [
    row.productNumber,
    '',
    '',
    '',
    '',
    english,
    replacePipesWithDashes(frenchSource),
  ];
}

export function vendorItemListRowsToCsv(
  rows: readonly FlaggedVendorItemListRow[],
): string {
  return `${rows
    .map((row) => vendorItemListUploadCells(row).map(csvCell).join(','))
    .join('\n')}\n`;
}
